import { PARSER_CONFIG } from '../constants';
import { TreeNode } from '../types';

import { BaseParser } from './BaseParser';

export class SpreadsheetParser extends BaseParser {
  readonly name = 'SpreadsheetParser';

  canParse(input: string): boolean {
    if (!input.includes('\t')) return false;

    const lines = input.split('\n', PARSER_CONFIG.maxLinesToCheck / 2);
    return lines.some((line) => line.split('\t').length > 1);
  }

  protected parseInternal(input: string): TreeNode[] {
    const lines = input.split('\n');
    return this.buildHierarchy(
      lines,
      (line) => this.findFirstNonEmptyCell(line.split('\t')),
      (line, level) => {
        const cells = line.split('\t');
        return cells[level]?.trim() || '';
      }
    );
  }

  private findFirstNonEmptyCell(cells: readonly string[]): number {
    const index = cells.findIndex((cell) => cell.trim() !== '');
    return index === -1 ? 0 : index;
  }
}
